import { useState, type FormEvent, type KeyboardEvent } from 'react';

interface ChatInputProps {
  onSubmit: (query: string) => void;
  disabled?: boolean;
  placeholder?: string;
}

export function ChatInput({ onSubmit, disabled, placeholder }: ChatInputProps) {
  const [value, setValue] = useState('');

  const submit = (e: FormEvent | KeyboardEvent) => {
    e.preventDefault();
    const trimmed = value.trim();
    if (!trimmed || disabled) return;
    onSubmit(trimmed);
    setValue('');
  };

  return (
    <div className="chat-input-shell">
      <form className="chat-input" onSubmit={submit}>
        <textarea
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) submit(e);
          }}
          placeholder={placeholder ?? "Ask anything about HRSA's data..."}
          rows={2}
          disabled={disabled}
          aria-label="Question"
        />
        <button type="submit" disabled={disabled || !value.trim()} aria-label="Send">
          ➤
        </button>
      </form>
      <p className="chat-input-footer-note">
        <span>🔒 Stateless · nothing is saved</span>
        <span aria-hidden="true"> · </span>
        <span>AI-generated · verify against linked sources</span>
      </p>
    </div>
  );
}
